export const getText = (key: string) => {
  return dictionary[key]
}

const dictionary = {
  close: 'Close',
  error: 'Error',
  landingPageTitle: 'Exclusive live events and original shows.',
  landingPageSubtitle:
    'To access our library of 200,000 live and on-demand sporting events, you will need a FloSports subscription.',
  landingLoginButton: 'Log In',
  signUpButton: 'Sign Up',
  landingSkipButton: 'Skip For Now',
  paywallTitle: 'Please subscribe or upgrade your subscription to watch this content.',
  paywallManagerSubscription: 'Manage Subscription',
  loginWithSmartphoneButton: 'With Smartphone',
  loginWithRemoteControlButton: 'With Remote Control',
  loginStep1Title: '1. Scan QR Code',
  loginStep1Description: 'Use your camera App or QR code reader\non your mobile device',
  loginStep1Description2: 'Or go to <color=0xffffffff>flosports.tv/activate</color>',
  loginStep1QrCodeUrl: 'https://www.flosports.tv/activate',
  loginForgotPasswordUrl: 'https://www.flolive.tv/forgot-password',
  loginStep2Title: '2. Enter the following code',
  loginStep2Description:
    'At the opened web page, enter the activation code. Your TV will be set up automatically.',
  enterYourEmailAddress: 'Enter your email address',
  continue: 'Continue',
  activationCodeError: 'There was an issue retrieving the activation code.',
  tryPasswordSignIn: 'You can still sign in with your email and password.',
  signInWithPassword: 'Sign in with password',
  enterYourPassword: 'Enter your password',
  loginRemoteLoginButton: 'Log In',
  showPassword: 'Show Password',
  hidePassword: 'Hide Password',
  loginRemoteForgotPasswordButton: 'Forgot Password?',
  loginRemoteError: 'Please double-check your email and password and try again.',
  loginRemoteErrorFooter:
    "If you're still having trouble, you can reset your password or contact support for assistance.",
  signUpUnlockContent: 'Unlock content with a subscription',
  signUpPleaseChoose: 'Please choose your subscription plan below.',
  signUpProductDescriptionMonthly:
    "What you receive:|Stream unlimited events, live or on-demand|Set your favorite sports and teams to quickly find the events you want to watch|Access exclusive interviews, analysis, rankings, and behind-the-scenes content|Watch replays or standout highlights on-demand, whenever it's convenient for you|Billed monthly",
  signUpProductDescriptionAnnual:
    "What you receive:|Stream unlimited events, live or on-demand|Set your favorite sports and teams to quickly find the events you want to watch|Access exclusive interviews, analysis, rankings, and behind-the-scenes content|Watch replays or standout highlights on-demand, whenever it's convenient for you|Billed annually",
  signUpProductDescription:
    'What you receive:|Stream unlimted events, live or on-demand|Access the full library of FloSports Originals|Get HD-quality streams and video|Watch on the web or the FloSports app - available on iOS, Android, Roku, Amazon Fire TV, Samsung, LG, Vizio, Google TV, and Apple TV',
  signUpSuccessful: 'You have successfully unlocked all PRO content!',
  signUpCreateAccountError: 'There was an error creating the account',
  signUpCreateAccountDuplicateEmailError: 'This email is already registered',
  signUpGenericOffersError: 'There was an error getting the offers. Please try again later.',
  signUpGenericBuyError: 'There was an error buying the package. Please contact customer service.',
  signUpLoginError: 'There was an error logging in into the account',
  signUpPasswordError: 'Password must be at least 6 characters in length.',
  forgotPasswordTitle: 'Password Recovery',
  forgotPasswordDescription:
    "Please enter your email address below, and we'll send you a link to reset your password.",
  forgotPasswordSendLinkButton: 'Send Reset Link',
  forgotPasswordQrCodeUrl: '',
  forgotPasswordQrCodeDescription:
    "Or scan this QR code with your smartphone camera, and you'll be taken to a password reset page on our website.",
  forgotPasswordResetLinkTitle: 'Reset Link Sent',
  forgotPasswordResetLinkDescription:
    ' Check your email inbox for a message from us with instructions on how to reset your password.',
  exitModalTitle: 'Exit FloSports',
  exitModalSubtitle: 'Are you sure you want to exit the app?',
  cancelButton: 'Cancel',
  tryAgainButton: 'Try Again',
  exitButton: 'Exit',
  accountDetails: 'Account Details',
  loginHeader: 'Log in or Sign up to start watching content on Flosports.',
  loginHeaderLg: 'Log in to start watching content on Flosports.',
  loginButton: 'Log In',
  changePasswordButton: 'Change Password',
  logoutButton: 'Log Out',
  usernameHeader: 'Username',
  emailHeader: 'Email',
  memberSinceHeader: 'Member since',
  countryHeader: 'Country',
  subscription: 'Subscription',
  subscriptionTypeHeader: 'Subscription Type',
  subscriptionStatusHeader: 'Subscription Status',
  nextPaymentHeader: 'Next Payment',
  manageSubscriptionHeader: 'Manage Subscription',
  manageSubscriptionDesc:
    "Scan this QR code with your smartphone camera, and you'll be taken to manage a subscription plan on the website.",
  manageSubscriptionDescVizio: 'Please visit vizio.com to manage your subscription',
  manageSubscriptionUrl: 'https://www.flolive.tv/account/subscriptions/',
  customerSupport: 'Customer Support',
  customerSupportHeader: "Got feedback? We'd love to hear it. ",
  customerSupportDesc: 'Scan QR code to submit your ticket',
  customerSupportUrl: 'https://support.flosports.tv/s/contactsupport',
  versionTag: 'Version: ',
  termsOfService: 'Terms of Service',
  termsOfServiceUrl: 'https://www.flosports.tv/terms-of-service/',
  goBackButton: 'Go Back',
  privacyPolicy: 'Privacy Policy',
  privacyPolicyUrl: 'https://www.flosports.tv/privacy-policy/',
  logoutModalTitle: 'Log Out?',
  logoutModalSubtitle: 'Are you sure you want to log out?',
  changePasswordModalTitle: 'Change Password',
  changePasswordModalDesc:
    "Scan this QR code with your smartphone camera, and you'll be taken to a change password page on our website.",
  changePasswordUrl: 'https://www.flolive.tv/login?redirect=/account/password',
  liveScores: 'Live Scores',
  liveScoresSettingTitle: 'Show Live Scores',
  liveScoresSettingDesc: 'Turn off live scores to prevent spoilers',
  off: 'OFF',
  on: 'ON',
  developerSettings: 'Developer Settings',
  favorites: 'Favorites',
  enable: 'Enable',
  disable: 'Disable',
  okButton: 'OK',
  forceCloseModalTitle: 'Confirm {{setting}} Setting',
  forceCloseModalSubtitle: 'Note: changing this setting will foce-close the app',
  eventStreams: 'Event Streams',
  connectionErrorTittle: 'No Internet Connection',
  connectionErrorSubtitle: "Can't load this page. Check your internet connection and try again.",
  reload: 'Reload',
  nonBffConnectionErrorTitle: 'Oops! It seems there was an error',
  playerConnectionErrorTitle: 'Oh snap! We are unable to play this video.',
  playerConnectionErrorSubtitle: 'Source error',
  genericErrorTitle: 'Hmm, something happened.',
  genericErrorText: 'We failed to load the content for this screen. Tap “reload” to try again.',
  authenticationRequired: 'Authentication Required',
  authenticationRequiredInfo: 'You must be logged in to add favorites.',
  // TODO: Remove template text strings
  pageNotFoundText:
    "We're sorry, the page you requested could not be found, please go back to the homepage",
  playerCarouselLiveTitle: 'Event Streams',
  playerCarouselVodTitle: 'Up Next',
  playerNoAudioNotificationMessage: 'Audio Disabled Due To Copyright Law',
  playerGenericHeartbeatError: 'An error occurred',
  playerScoresButton: 'Scores/Stats',
  playerBracketsButton: 'Brackets',
  playerFeedbackButton: 'Report',
  playerFeedbackModalTitle: 'Provide Feedback',
  playerScoresDescription: 'Scan the QR code with your smartphone camera to see the Scores/Stats',
  playerBracketsDescription:
    'Scan the QR code with your smartphone camera to see the Event Brackets',
  playerFeedbackDescription: 'Scan the QR code with your smartphone camera to report video issues',
  playerFeedbackUrl: 'https://flosports.typeform.com/to/FzLanulr',
  playerFeedbackFooterText: 'Or go to ',
  playerFeedbackFooterLink: 'flosports.tv/feedback',
  playerUpNextCountdown: 'Playing next video in <color=0xffffffff>{{timeLeft}}</color>',
  logout: 'Log out',
  backButton: 'Back',
  pageNotFoundTitle: 'Page Not Found',
  settings: 'Settings',
  pauseButton: 'Pause',
  playButton: 'Play',
  nextButton: 'Next',
  exit: 'Exit',
  dictionary: 'Dictionary',
  subscriptionTypePro: 'Pro',
  subscriptionTypeFree: 'Free',
  success: 'Success',
  signUp: 'Sign Up',
  lgSignUpMessage: 'Visit us online to create your account',
  lgSignUpQrCodeText: 'Or go to <color=0xffffffff>flosports.tv/lg-join-now</color>',
  lgSignUpQrUrl: 'https://www.flosports.tv/lg-join-now',
  vizioSignUpMessage: 'Visit us online to create your account',
  vizioSignUpQrCodeText: 'Or go to <color=0xffffffff>flosports.tv/vizio-join-now</color>',
  vizioSignUpQrUrl: 'https://www.flosports.tv/vizio-join-now',
}
